 
    import { Options   } from "vue-class-component";   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import {  Vue  } from "vue-class-component";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import CardRh from   "@/components/cards/ManzaCard.vue"
    
    @Options({
        name: "RelatorioPagamentoInstrutorIndex",
        components: {  CardRh },  
        emits: [  'update-turma-alterado'],  
    }) 
    export default class RelatorioPagamentoInstrutorIndex  extends Vue {
        
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly service!: any
        @Prop( ) readonly cpf!: any
        @Prop( ) readonly dataAulaMin!: any
        @Prop( ) readonly dataAulaMax!: any

        public processando = false;  
        public dados: any  = null ;   
        public SiteUtils: any  = SiteUtils ;   
          
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin , PerfilConfig.ChefeSTE , PerfilConfig.AuxSTE ] , this.perfis ); 
        }
 
        @Watch('cpf')
        public modeloAlterado(){  
            this.dados = null;
            if(this.cpf != null ){
                this.service.getRelatorioPagamentoInstrutor(this.cpf, this.dataAulaMin,this.dataAulaMax) 
                .then(response => {   
                    this.dados =  JSON.parse(JSON.stringify( response ));    
                })
                .catch(error => {
                    this.dados = null;  
                });  
            }
        } 
    } 
